// Types
import type { TSearchPerformer } from '~/misc/search/types';
import type { TManagerSearchCompany } from '~/modules/manager/types';

// Services
import { AbstractDataClient } from '~/misc/services/data-client';

// Models
import { ManagerCompanyModel } from '~/modules/manager/models/company.model';

export class CompanySearchPerformer
  extends AbstractDataClient<ManagerCompanyModel>
  implements TSearchPerformer
{
  constructor(protected companyIdToExclude: number | null) {
    super(new ManagerCompanyModel());
  }

  public searchByQuery(query: string): Promise<TManagerSearchCompany[]> {
    return this.request('search', { exclude: [this.companyIdToExclude], q: query });
  }
}
